// extracted by mini-css-extract-plugin
export default {"gray500":"#adb5bd","CardImage":"SignUpPreview_CardImage__dgnCj","midFrame":"SignUpPreview_midFrame__x1nuR","innerFrame":"SignUpPreview_innerFrame__KDZmR"};